import { NocoHttpClient } from '@noco/http-client';
import { createConfigurationWithToken } from '../utils';
var Configuration = NocoHttpClient.Configuration;
var ContactApi = /** @class */ (function () {
    function ContactApi(basePath, fetchApi) {
        this.basePath = basePath;
        this.fetchApi = fetchApi;
    }
    ContactApi.initialize = function (basePath, fetchApi) {
        if (!ContactApi.instance) {
            ContactApi.instance = new ContactApi(basePath, fetchApi);
        }
        return ContactApi.instance;
    };
    ContactApi.prototype.ApiFactory = function (idToken) {
        var config = createConfigurationWithToken({
            basePath: this.basePath,
            fetchApi: this.fetchApi,
            idToken: idToken,
            type: 'user'
        });
        return new NocoHttpClient.ApiUserV1ContactApi(new Configuration(config));
    };
    return ContactApi;
}());
export { ContactApi };
